export const DEFAULT_ORG_ID = 'ORGBRAIN_DEFAULT';
export const DEFAULT_USER_FOR_SUBSCRIPTIONS = 'bb@fintechneo.com';
export const APP_SELECTOR_SCREEN = '/select';
export const INTERCEPTOR_SKIP_HEADER = 'X-Skip-Interceptor';
export const ERROR_THROW_ME = 'X-Throw-Error';
export const NO_LOGOUT_HEADER = 'X-Nologout-Interceptor';
export const FAKE_MONGO_ID = '000000000000000000000000';
export const NEW_ITEM_NO_MONGO_ID = '@addedViaDropdown@';
export const CHANNEL_PULSE_PERIOD = 30000; // How often rtoi send HEARTBEATS
export const CHANNEL_PULSE_PERIOD_POLL = 1000; // Keep checcking at this rate
export const EMAIL_REGEXP_THAT_WORKS =
  /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

// Numbers, letters, dashes
export const ORG_ID_REPLACE_REGEXP = /[^0-9a-zA-Z]/g;
export const ORG_ID_ALLOWED_REGEXP = /^[0-9a-zA-Z]+$/;
// https://invisible-characters.com/
// U+205F MEDIUM MATHEMATICAL SPACE
export const INVISIBLE_CHAR_SPACE_ALIKE = ' ';
// U+2008 PUNCTUATION SPACE
export const INVISIBLE_CHAR_SPACE_ALIKE2 = ' ';
// https://en.wikipedia.org/wiki/Zero-width_space
export const ZERO_WIDTH_SPACE = '​';
